
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';
  import routeService from '@/services/route.service';

  import twitchService from '@/services/twitch.service';
  import { ITwitchCallbackRequestModel } from '../../models/twitch.model';

  @Component({
    computed: {
      ...mapGetters([
        'user',
        'token',
        'redirectUrl'
      ])
    }
  })
  export default class TwitchCallback extends Vue {
    data() {
      return {
        unwatch: null
      }
    };

    created() {
      this.$data.unwatch = this.$store.watch(() => this.$store.getters.token, token => {
        this.$store.dispatch("updateIsLinkingTwitchLoading", true);
        this.$store.dispatch("updateIsLoading", true);

        if (token == null) {
          this.$store.dispatch("updateIsLinkingTwitchLoading", false);
          this.$store.dispatch("updateIsLoading", true);
          routeService.redirectToLogin(this);
        }

        const model = {
          Code: this.$route.query.code,
          CallbackPath: "/twitch/callback",
        } as ITwitchCallbackRequestModel;
        twitchService.callbackTwitch(this, model, token);
      });
    }

    destroyed() {
      this.$data.unwatch();
    }
  }
